import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

const labels: Record<string, string> = {
  draft: 'Настройка не завершена', ready: 'Готов к запуску', working: 'Работает', waiting: 'Ожидает данные', attention: 'Требует внимания', stopped: 'Остановлен', payment_required: 'Требуется оплата',
  not_started: 'Пробный период не начат', trialing: 'Пробный период', active: 'Оплачено', past_due: 'Просрочено', disabled: 'Отключено',
  queued: 'В очереди', fetching: 'Загружаем данные', uploading: 'Передаём', processing: 'Обрабатывается', completed: 'Обработка завершена', partial: 'Обработка завершена', failed: 'Ошибка обработки',
  connected: 'Подключён', error: 'Ошибка', reconnect_required: 'Нужно переподключить', created: 'Создана', exists: 'Уже создана', not_created: 'Не создана',
};

function tone(value: string): string {
  if (['working', 'active', 'completed', 'connected', 'created', 'exists'].includes(value)) return 'bg-success-soft text-success';
  if (['waiting', 'processing', 'queued', 'fetching', 'uploading', 'trialing', 'not_started', 'not_created'].includes(value)) return 'bg-info-soft text-info';
  if (['ready', 'partial', 'past_due'].includes(value)) return 'bg-warning-soft text-warning';
  if (['attention', 'payment_required', 'failed', 'error', 'reconnect_required', 'disabled'].includes(value)) return 'bg-destructive/10 text-destructive';
  return 'bg-muted text-muted-foreground';
}

export function StatusBadge({ value, label }: { value: string; label?: string }) {
  return (
    <Badge variant="ghost" className={cn('gap-1.5 rounded-md px-2', tone(value))}>
      <span className="status-dot" aria-hidden="true" />
      {label ?? labels[value] ?? value}
    </Badge>
  );
}

export const statusLabel = (value: string) => labels[value] ?? value;
